import { createRouter, createWebHistory } from 'vue-router'
import Dashboards from '@views/DashboardsList.vue'
import LandingView from '@/views/LandingView.vue'
import DashboardController from '@/components/DashboardController.vue'
import EditorView from '@views/EditorView.vue'


const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingView
  },
  {
    path: '/dashboard/active/:groupId',
    name: 'Dashboard Public group',
    component: DashboardController
  },
  {
    path: '/dashboard/active',
    name: 'Dashboard Public',
    component: DashboardController
  },
  {
    path: '/dashboard/dashboard/:id',
    name: 'Dashboard Public group',
    component: DashboardController
  },  
  {
    path: '/admin',
    name: 'Dashboard list',
    meta: { requiresAuth: true },
    component: Dashboards
  },
  {
    path: '/admin/dashboard/:id',
    name: 'Dashboard',
    meta: { requiresAuth: true },
    component: DashboardController
  },
  {
    path: '/admin/editor/:id',
    name: 'Editor',
    meta: { requiresAuth: true },
    component: EditorView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ? '/zeitmeilen-dashboard' : '/'),
  routes
})

export default router
